(function () {
  function initDesktopMenu() {
    const header = document.querySelector('#pageheader');
    const logoArea = header?.querySelector('.logo-area');
    const proxyNav = document.querySelector('#proxy-nav');
    const sourceList = proxyNav?.querySelector('.navigation__tier-1');

    if (!header || !logoArea || !sourceList) {
      return;
    }

    /*
     * Prevent duplicate initialization.
     */
    if (document.querySelector('.desktop-drawer-toggle')) {
      return;
    }


    /* =====================================================
       CREATE HAMBURGER
       ===================================================== */

    const toggle = document.createElement('button');

    toggle.type = 'button';
    toggle.className = 'desktop-drawer-toggle';
    toggle.setAttribute('aria-label', 'Open menu');
    toggle.setAttribute('aria-expanded', 'false');

    toggle.innerHTML = `
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        aria-hidden="true"
      >
        <path d="M3 6h18"></path>
        <path d="M3 12h18"></path>
        <path d="M3 18h18"></path>
      </svg>
    `;

    logoArea.appendChild(toggle);


    /* =====================================================
       CREATE DRAWER
       ===================================================== */

    const shell = document.createElement('div');

    shell.className = 'desktop-menu-shell';

    shell.innerHTML = `
      <div class="desktop-menu-backdrop"></div>

      <aside
        class="desktop-menu-drawer"
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
      >

        <div class="desktop-menu-drawer__header">

          <div class="desktop-menu-drawer__logo"></div>

          <button
            type="button"
            class="desktop-menu-drawer__close"
            aria-label="Close menu"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              aria-hidden="true"
            >
              <path d="M6 6l12 12"></path>
              <path d="M18 6L6 18"></path>
            </svg>
          </button>

        </div>


        <div class="desktop-menu-drawer__content">

          <div class="desktop-menu-main">
            <ul class="desktop-menu-list"></ul>
          </div>


          <div class="desktop-submenu">

            <button
              type="button"
              class="desktop-submenu-back"
            >
              ← Back
            </button>

            <h3 class="desktop-submenu-title"></h3>

            <ul class="desktop-submenu-links"></ul>

          </div>

        </div>

      </aside>
    `;

    document.body.appendChild(shell);


    const drawer = shell.querySelector('.desktop-menu-drawer');
    const backdrop = shell.querySelector('.desktop-menu-backdrop');
    const closeButton = shell.querySelector('.desktop-menu-drawer__close');

    const menuList = shell.querySelector('.desktop-menu-list');

    const submenu = shell.querySelector('.desktop-submenu');
    const submenuTitle = shell.querySelector('.desktop-submenu-title');
    const submenuLinks = shell.querySelector('.desktop-submenu-links');
    const submenuBack = shell.querySelector('.desktop-submenu-back');


    /* =====================================================
       CLONE LOGO
       ===================================================== */

    const originalLogo = document.querySelector(
      '#pageheader .logo__link'
    );

    if (originalLogo) {
      const logoClone = originalLogo.cloneNode(true);

      /*
       * Transparent headers normally contain two logo images.
       * Keep them, but the CSS will constrain the result.
       */
      shell
        .querySelector('.desktop-menu-drawer__logo')
        .appendChild(logoClone);
    }


    /* =====================================================
       BUILD MENU FROM SYMMETRY'S EXISTING MENU

       Important:
       We are NOT hardcoding your menu.

       #proxy-nav remains the source of truth.
       ===================================================== */

    const sourceItems = sourceList.querySelectorAll(
      ':scope > .navigation__item'
    );

    sourceItems.forEach((sourceItem) => {
      const sourceLink = sourceItem.querySelector(
        ':scope > .navigation__link'
      );

      if (!sourceLink) return;


      const li = document.createElement('li');

      li.className = 'desktop-menu-item';


      const link = document.createElement('a');

      link.className = 'desktop-menu-link';

      link.href = sourceLink.href;

      const label = document.createElement('span');

      label.textContent = sourceLink.textContent.trim();

      link.appendChild(label);


      /*
       * Symmetry marks menu items with children using this
       * class and aria-controls.
       */
      const hasChildren =
        sourceItem.classList.contains(
          'navigation__item--with-children'
        );


      if (hasChildren) {
        const chevron = document.createElement('span');

        chevron.className = 'desktop-menu-chevron';
        chevron.innerHTML = '›';

        link.appendChild(chevron);


        /*
         * Example from Symmetry:
         *
         * aria-controls="NavigationTier2-2"
         *
         * We'll attempt to use the existing submenu
         * generated by Symmetry.
         */
        link.addEventListener('click', function (event) {
          const controlsId =
            sourceLink.getAttribute('aria-controls');

          if (!controlsId) {
            return;
          }

          const sourceSubmenu =
            document.getElementById(controlsId);

          if (!sourceSubmenu) {
            return;
          }


          const links = Array.from(
            sourceSubmenu.querySelectorAll('a[href]')
          );


          /*
           * If Symmetry didn't render submenu links,
           * just let the normal collection link work.
           */
          if (!links.length) {
            return;
          }


          event.preventDefault();

          openSubmenu(
            sourceLink.textContent.trim(),
            links
          );
        });
      }


      li.appendChild(link);

      menuList.appendChild(li);
    });


    /* =====================================================
       OPEN SUBMENU
       ===================================================== */

    function openSubmenu(title, links) {
      submenuTitle.textContent = title;

      submenuLinks.innerHTML = '';


      /*
       * Avoid duplicates sometimes produced by mega menus.
       */
      const usedLinks = new Set();


      links.forEach((sourceLink) => {
        const text = sourceLink.textContent.trim();
        const href = sourceLink.href;

        if (!text || !href) {
          return;
        }

        const key = `${text}-${href}`;

        if (usedLinks.has(key)) {
          return;
        }

        usedLinks.add(key);


        const item = document.createElement('li');

        const link = document.createElement('a');

        link.href = href;
        link.textContent = text;


        item.appendChild(link);

        submenuLinks.appendChild(item);
      });


      drawer.classList.add('show-submenu');

      drawer.scrollTop = 0;
    }


    /* =====================================================
       BACK FROM SUBMENU
       ===================================================== */

    submenuBack.addEventListener('click', function () {
      drawer.classList.remove('show-submenu');

      submenuLinks.innerHTML = '';
    });


    /* =====================================================
       OPEN / CLOSE
       ===================================================== */

    function openMenu() {
      shell.classList.add('is-open');

      toggle.setAttribute(
        'aria-expanded',
        'true'
      );

      document.documentElement.style.overflow = 'hidden';

      document.body.style.overflow = 'hidden';
    }


    function closeMenu() {
      shell.classList.remove('is-open');

      drawer.classList.remove('show-submenu');

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

      document.documentElement.style.overflow = '';

      document.body.style.overflow = '';
    }


    toggle.addEventListener(
      'click',
      openMenu
    );


    closeButton.addEventListener(
      'click',
      closeMenu
    );


    backdrop.addEventListener(
      'click',
      closeMenu
    );


    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          shell.classList.contains('is-open')
        ) {
          closeMenu();
        }
      }
    );


    /*
     * If user resizes into mobile,
     * close desktop drawer.
     */
    window.addEventListener(
      'resize',
      function () {
        if (window.innerWidth < 768) {
          closeMenu();
        }
      }
    );
  }


  /* Normal storefront load */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initDesktopMenu
    );
  } else {
    initDesktopMenu();
  }


  /*
   * Shopify Theme Editor can reload header sections.
   */

  document.addEventListener(
    'shopify:section:load',
    function () {
      initDesktopMenu();
    }
  );
})();